import $ from 'jquery'

export default class SubmitNewsletter {
	constructor() {
	  if (!document.querySelector('#newsletter-form')) return false;
  
	  $('#newsletter-form').on('submit', (e) => {
		e.preventDefault();
		$('.newsletter-info--error, .newsletter-info--ok').hide();
		const url = $(e.target).attr('action');
		const action = $('#newsletter_action').val();
		let email = $('#newsletter_email').val();
		let additionalInfo = $('input[name="additional_info"]').val();
		
		if (!email.length || !this.validateEmail(email) || additionalInfo !== '') {
		  $('.newsletter-info--error').show();
		} else {
		  $.post(
			url,
			{
			  action: action,
			  mail: email,
			  additional_info: additionalInfo
			},
			function (o) {
			  if (!o.error) {
				$('#newsletter-form').hide();
				$('.newsletter-info--ok').show();
			  }
			},
			'json'
		  );
		}
	  });
	}
  
	validateEmail(email) {
	  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	  return re.test(email);
	}
  }


export function rodoObligation() {
	if (!document.querySelector('#newsletterMoreRodoToggle')) return false;
	$('#newsletterMoreRodoToggle').on('click', function(e){
		var expandLabel = $(this).data('expand_label');
		var foldLabel = $(this).data('fold_label');
		if($('#newsletterMoreRodo').is(':visible')){
			$('#newsletterMoreRodo').slideUp()
			$('#newsletterMoreRodoToggle .txt').html(expandLabel)
			$('#newsletterMoreRodoToggle .arrow').removeClass('u--arrow-up').addClass('u--arrow-down')
		} else {
			$('#newsletterMoreRodo').slideDown()
			$('#newsletterMoreRodoToggle .txt').html(foldLabel)
			$('#newsletterMoreRodoToggle .arrow').addClass('u--arrow-up').removeClass('u--arrow-down')
		}

		e.preventDefault();
		return false;
	})
}

